'use client';

import React, { ReactNode, createContext, useContext, useState } from 'react';

type IDataManagementProvider = {
  children: ReactNode;
};

type IDataManagementContext = {
  updateSingleDataManagementData: any;
  dataManagementData: any;
  updateDataManagementData: any;
  resetDataManagementData: any;
};

export const DataManagementContext = createContext({} as IDataManagementContext);

export function useDataManagementContext() {
  return useContext(DataManagementContext);
}

export function DataManagementProvider({ children }: IDataManagementProvider) {
  //   const [events, setEvents] = useState<any>();
  const [dataManagementData, setDataManagementData] = useState<any>([]);

  const updateDataManagementData = (data: any) => {
    setDataManagementData((prev: any) => [...prev, ...data]);
  };
  const updateSingleDataManagementData = (data: any) => {
    setDataManagementData((prev: any) => {
      const newArray = [...prev];
      const index = newArray?.findIndex((item: any) => item?.id === data?.id);
      newArray[index] = data;
      return newArray;
    });
  };
  const resetDataManagementData = () => {
    setDataManagementData([]);
  };

  //   useEffect(() => {
  //     const startLoaderEvent = new CustomEvent('startLoading');

  //     const stopLoaderEvent = new CustomEvent('stopLoading');
  //     setEvents({ startLoaderEvent, stopLoaderEvent });
  //   }, []);

  return (
    <DataManagementContext.Provider
      value={{
        dataManagementData,
        updateDataManagementData,
        resetDataManagementData,
        updateSingleDataManagementData,
      }}
    >
      {children}
    </DataManagementContext.Provider>
  );
}
